const PurchaseInput = () => import("@/views/purchases/input.vue");
const PurchaseList = () => import("@/views/purchases/list.vue");

export default [
    { path: "/purchases/input/:id", name: "purchase_input", component: PurchaseInput, meta: { title: "Invoice:" }, props: true },
    { path: "/purchases/list", name: "purchase_list", component: PurchaseList, meta: { title: "Input list" }, props: false },
];
